import React, { forwardRef, useRef, useImperativeHandle } from "react";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { FORM_ACTIONS } from "../FormActions";

import { SovosFilterTextEntry, SovosFormGroup, SovosTextField } from "mosaic-react";

const TicketForm = (props, ref) => {
    const { data, projects, status, onChange, onSave } = props;
    const formRef = useRef();
    const { ticketNumber, ticketDescription, projectId } = data || {};

    const { i18n, user } = useGlobalValue();

    const handleChange = (e, prop, value) => {
        onChange &&
            onChange({
                originalEvent: e,
                target: {
                    value: {
                        data: {
                            ...data,
                            [prop]: value,
                        },
                    },
                },
            });
    };

    const allProjects =
        projects && projects.items
            ? projects.items.map(({ id, description, organization, taxRegistrationNumber }) => ({
                  id,
                  name: `${id} - ${taxRegistrationNumber} - ${description} (${(organization || {}).name})`,
              }))
            : [];

    useImperativeHandle(ref, () => ({
        submit: () => {
            formRef.current.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
        },
    }));

    return status !== "loading" ? (
        <form
            ref={formRef}
            onSubmit={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (formRef.current.checkValidity()) {
                    data["__typename"] = "Ticket";
                    data["userId"] = (user || {}).id;
                    onSave && onSave();
                } else {
                    formRef.current.reportValidity();
                }
            }}
        >
            <SovosFormGroup>
                <SovosFilterTextEntry
                    label={i18n`Select Project`}
                    data={[allProjects ? allProjects.find(({ id }) => id === projectId) : null]}
                    AutocompleteProps={{
                        loading: allProjects?.length === 0,
                        options: allProjects || [],
                        getOptionLabel: (option) => option.name,
                        isOptionEqualToValue: (option, value) => option.id === value.id,
                    }}
                    onChange={(e) => {
                        const [eventValue] = e;
                        handleChange(e, "projectId", eventValue.id);
                    }}
                />
                <SovosTextField
                    label={i18n`Ticket Number`}
                    placeholder={i18n`Enter a ticket number`}
                    value={ticketNumber || ""}
                    required
                    onChange={(e) => {
                        handleChange(e, "ticketNumber", e.target.value);
                    }}
                />
                <SovosTextField
                    label={i18n`Description`}
                    placeholder={i18n`Enter a ticket description`}
                    value={ticketDescription || ""}
                    required
                    onChange={(e) => {
                        handleChange(e, "ticketDescription", e.target.value);
                    }}
                />
            </SovosFormGroup>
        </form>
    ) : null;
};

const TicketFormRef = forwardRef(TicketForm);

TicketFormRef.queries = (args) => {
    return [
        {
            resource: "projects",
            args: { pageSize: 0 },
            body: "items{id,taxRegistrationNumber,description,organization{name}}",
        },
    ].filter((q) => q);
};

TicketFormRef.dataMapper = ["projects", "ticket", "data"];

TicketFormRef.actions = [FORM_ACTIONS.SAVE];

export default TicketFormRef;
